import React, { useState, useEffect, useRef } from "react";
import "./MasterKeys.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import addIcon from "../../assets/icons/addItemIcon.svg";
import Pagination from "../../components/Pagination/Pagination";
import AddMasterKeyModal from "../../components/AddMasterKeyModal/AddMasterKeyModal";
import { createFBJsonKey, getFBJsonKeys, updateFBJsonKey } from "../../apis/flowBuilderApi/flowBuilderApi";
import editIcon from "../../assets/icons/editIcon.svg";
import Spinner from "../../layouts/spinner/Spinner";
import filterIcon from "../../assets/icons/filtericon.svg";

function Maskerkeys() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [configList, setConfigList] = useState<any[]>([]);
  const [originalConfigList, setOriginalConfigList] = useState<any[]>([]);
  const [updateItemData, setUpdateItemData] = useState<any>({});
  const [modaltitle, setModaltitle] = useState("");
  const [updateModalFlag, setUpdateModalFlag] = useState(false);


  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState<any>(10);

  // Get current Rows
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = configList.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  const rowCountRange = [10, 25, 50, 100];

  const [openAddItemModal, setOpenAddItemModal] = useState(false);

  const [openFilter, setOpenFilter] = useState(false);
  let filterRef = useRef<any>("");
  const filterSearchInputref = useRef<any>(null);

  const columns = [
    { field: "Active_Flg", headerName: "Active" },
  ];
  const [seletedFilterType, setSeletedFilterType] = useState<any>(columns[0]);


  useEffect(() => {
    getAllConfig();
  }, []);


  useEffect(() => {
    let handler = (e: any) => {
      if (!filterRef?.current.contains(e.target)) {
        setOpenFilter(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const getAllConfig = () => {
    setLoading(true);
    filterSearchInputref.current.value = "";
    getFBJsonKeys((resp: any) => {
      if (resp) {
        setConfigList(resp);
        setOriginalConfigList(resp);
      } else {
        navigate("/errorInvalid");
      }
      setLoading(false);
    });
  };


  const handleFilterChange = (index: any) => {
    filterSearchInputref.current.value = "";
    setSeletedFilterType(columns[index]);
    setConfigList(originalConfigList);
  };

  const handleSearchByType = (value: any) => {
    let searchValue = filterSearchInputref.current.value.toLowerCase();
    let filterType = seletedFilterType.field;
    if (searchValue) {
      let cls = originalConfigList.filter((item: any) => {
        return item[filterType].toLowerCase().includes(searchValue);
      });
      setConfigList(cls);
    } else {
      setConfigList(originalConfigList);
    }
  };

  const handleSearch = (value: any) => {
    let searchValue = value.toLowerCase();
    if (searchValue.length >= 2) {
      let cls = originalConfigList.filter((item: any) => {
        return (
          item.name?.toLowerCase().includes(searchValue) ||
          item.displayname?.toLowerCase().includes(searchValue) ||
          item.Description?.toLowerCase().includes(searchValue)
        );
      });
      setConfigList(cls);
    } else {
      setConfigList(originalConfigList);
    }
  };


  const handleAddItemSubmit = (data: any) => {
    setLoading(true);
    createFBJsonKey(data,(resp: any) => {
      if (resp) {
        setOpenAddItemModal(false);
        getAllConfig();
      }
      setLoading(false);
    });
  };
  const handleUpdateItemSubmit = (data: any) => {
    setLoading(true);
    let itemData={...updateItemData};
    for (const [key, value] of Object.entries(data)) {
      itemData[key]=value;
    }
    updateFBJsonKey(itemData,(resp: any) => {
      if (resp) {
        setOpenAddItemModal(false);
        getAllConfig();
      }
      setLoading(false);
    });
  };
  const handleOpenUpdateModal = (data: any) => {
    setUpdateItemData(data);
    setModaltitle("Edit");
    setUpdateModalFlag(true);
    setOpenAddItemModal(true);
  };
  const handleItemSubmit = (data: any) => {
    if(updateModalFlag){
      handleUpdateItemSubmit(data);
    }else{
      handleAddItemSubmit(data);
    }
  };

  return (
    <>
      <div className="tab-page-layout-1">
        <div className="tab-page-layout-1-header config-header-section">
          <div className="tab-page-layout-1-header-title-label">Master key List</div>
          <div className="tab-header-search">
            <div className="search-box config-search-box">
              <FontAwesomeIcon
                className="search-icon"
                icon={["fas", "magnifying-glass"]}
              />

              <div className="search-input-section">
                <input
                  className="search-input"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="tab-header-env-dropdown-section">
          </div>
          <div></div>
          <div className="tab-header-right-div ">
          <div
              className="filter-btn-section header-icon"
              onClick={() => {
                setOpenFilter(!openFilter);
              }}
            >
              <img src={filterIcon} className="icon-md" alt=""/>
            </div>
            <div
              className="add-btn-section header-icon"
              onClick={() => {
                setModaltitle("Add");
                setUpdateItemData(false)
                setUpdateModalFlag(false);
                setOpenAddItemModal(true)}}
            >
              <img src={addIcon} className="icon-md" alt=""/>
            </div>
          </div>
        </div>
        <div className="tab-page-layout-1-body">
          <div className="tab-page-layout-1-list-header config-list-header">
            <div className="tab-page-layout-1-li-item  font-bold">Key Name</div>
            <div className="tab-page-layout-1-li-item  font-bold">
              Display Name
            </div>
            <div className="tab-page-layout-1-li-item  font-bold">
              Description
            </div>
            <div className="tab-page-layout-1-li-item  font-bold">Active</div>
            <div className="tab-page-layout-1-li-item  font-bold">Key Location</div>

            <div className="tab-page-layout-1-li-item  font-bold">Actions</div>
          </div>
 
          <ul
            className="tab-page-layout-1-list-section config-list-section"
            id="client-list-section"
          >
             {loading ? 
             <div className="text-center">
              <Spinner/> 
             </div>
            :<>
            {currentRows.map((item: any, i) => {
              return (
                <li
                  className="tab-page-layout-1-list-item-section config-list-item-section"
                  key={i}
                >
                  <div className="tab-page-layout-1-li-item" title={item.name}>
                    {item.name}
                  </div>
                  <div className="tab-page-layout-1-li-item" title={item.displayname}>
                    {item.displayname}
                  </div>
                  <div className="tab-page-layout-1-li-item" title={item.Description}>
                    {item.Description}
                  </div>
                  <div className="tab-page-layout-1-li-item" title={item.Active_Flg}>
                    {item.Active_Flg}
                  </div>
                  <div className="tab-page-layout-1-li-item" title={item.Active_Flg}>
                    {item.Key_Location}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    <div onClick={()=>handleOpenUpdateModal(item)}>
                        <img src={editIcon} className="icon-wd-sm" alt=""/>
                      </div>
                  </div>
                </li>
              );
            })}
            </>}
          </ul>

          <div className="tab-page-layout-1-list-footer config-list-footer">
            <div className="row-count-section">
              <div className="row-count-label center-div">Show per page</div>
              <div className="row-count-dropdown-section center-div">
                <select
                  name="filter-column"
                  id=""
                  className="column-dropdown row-count-dropdown  dropdown-arrow-1"
                  onChange={(e) => setRowsPerPage(e.target.value)} 
                >
                  {rowCountRange.map((item: any, i) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="page-number-section center-div">
              <div className="entries-count">
                {rowsPerPage * currentPage - rowsPerPage + 1} to{" "}
                {((rowsPerPage * currentPage)<configList.length)?rowsPerPage * currentPage:configList.length} of {configList.length} entries
              </div>
              <Pagination
                rowsPerPage={rowsPerPage}
                totalRows={configList.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            </div>
          </div>
        </div>
      </div>


   {/* Filter Popup */}
   <div
        className={`filter-popup ${openFilter ? "active" : "inactive"}`}
        ref={filterRef}
      >
        <div className="filter-popup-body">
          <div className="column-dropdown-section center-div">
            <select
              name="filter-column"
              id=""
              className="column-dropdown dropdown-arrow-1"
              onChange={(e) => handleFilterChange(e.target.value)}
            >
              {columns.map((item: any, i) => (
                <option value={i} key={item.field}>
                  {item.headerName}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-input-section center-div">
            <select
              ref={filterSearchInputref}
              className="filter-input"
              onChange={(e) => {
                handleSearchByType(e.target.value);
              }}
            >
              <option value="">Select an option</option>
              <option value="Y">Y</option>
              <option value="N">N</option>
            </select>
          </div>
        </div>
      </div>



      {/* Add item modal */}
      <AddMasterKeyModal 
        loading={loading}
        openAddItemModal={openAddItemModal} 
        data={updateItemData} 
        title={modaltitle} 
        handleCloseAddItemModal={()=>{
          setUpdateModalFlag(false);
          setOpenAddItemModal(false);
        }}
        handleSubmit={(e)=>{
          handleItemSubmit(e);
        }}
       />

    </>
  );
}

export default Maskerkeys;
